import type { ClassifyExpenseResponse, ExpenseTypeDto } from './schemas';
import type { ClassifiedExpenseType, ExpenseType } from '../model/types';

/** Anti-corruption: expense-type DTO → domain. `_id` becomes the id sent as `expense_type_id`. */
export function toExpenseType(dto: ExpenseTypeDto): ExpenseType {
  return {
    id: dto._id,
    name: dto.name ?? '',
    description: dto.description ?? '',
    image: dto.image ?? null,
    color: dto.color ?? null,
  };
}

/**
 * Classify response → the suggested category (`{ id, name }`), or null when nothing usable was
 * classified. Reads the id/name from whichever shape the backend used (nested `expense_type`
 * object, bare id string, or flat fields). Either may be empty — the caller matches `id` against
 * the loaded expense-type list first and falls back to the `name`.
 */
export function toClassifiedExpenseType(
  res: ClassifyExpenseResponse,
): ClassifiedExpenseType | null {
  const data = res.data;
  if (!data) return null;
  const et = data.expense_type;
  const nested = typeof et === 'string' ? { _id: et, id: null, name: null } : et ?? null;
  const id = nested?._id ?? nested?.id ?? data.expense_type_id ?? data._id ?? data.id ?? '';
  const name = nested?.name ?? data.expense_type_name ?? data.name ?? '';
  if (!id && !name) return null;
  return { id, name };
}
